import React, { useContext } from 'react';
import cn from 'classnames';

import styles from './LangToggler.module.css';
import LanguageContext from '../../context/LanguageContext';

export default function LangToggler({ handleToggle }) {
    const { language } = useContext(LanguageContext);

    return (
        <div className={cn(styles.switch)} onClick={() => handleToggle()}>
            <div
                className={cn(
                    styles.circle,
                    {
                        [styles.left]: language === 'ua',
                    },
                    {
                        [styles.right]: language === 'en',
                    }
                )}
            ></div>
            <span
                className={cn(styles.on, {
                    [styles.active]: language === 'ua',
                })}
            >
                UA
            </span>
            <span
                className={cn(styles.off, {
                    [styles.active]: language === 'en',
                })}
            >
                EN
            </span>
        </div>
    );
}
